import { SimulationQuery } from 'client/app/gql';

export const isComputationalSimulation = (
  tasks?: SimulationQuery['simulation']['tasks'],
) => !tasks || tasks.length === 0;
